//TODO improve this to also take in consideration strings and number comparisons
export const isEqual = (prev: unknown, curr: unknown) => JSON.stringify(prev) === JSON.stringify(curr);
